var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6668 3.16699H9.61281L8.19354 1.03808C8.03898 0.806243 7.77879 0.666992 7.50016 0.666992H3.3335C1.95278 0.666992 0.833496 1.78628 0.833496 3.16699V14.8337C0.833496 16.2144 1.95278 17.3337 3.3335 17.3337H16.6668C18.0475 17.3337 19.1668 16.2144 19.1668 14.8337V5.66699C19.1668 4.28628 18.0475 3.16699 16.6668 3.16699ZM3.3335 2.33366H7.05418L8.47345 4.46258C8.62801 4.69441 8.8882 4.83366 9.16683 4.83366H16.6668C17.1271 4.83366 17.5002 5.20675 17.5002 5.66699V14.8337C17.5002 15.2939 17.1271 15.667 16.6668 15.667H3.3335C2.87326 15.667 2.50016 15.2939 2.50016 14.8337V3.16699C2.50016 2.70675 2.87326 2.33366 3.3335 2.33366Z",
    fill: "#182F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFolder);
export default __webpack_public_path__ + "static/media/black-folder.803d8cbee9cb8751cf15c82848739fdd.svg";
export { ForwardRef as ReactComponent };